export function removeForbiddenWords(inputString: string, forbiddenWords: string[]): string {
  if (!inputString) return inputString;
  // Use a regular expression to match and remove the forbidden words
  const regex = new RegExp(forbiddenWords.join('|'), 'gi');
  const outputString = inputString.replace(regex, '');

  return outputString;
}
